import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { AppConfigService } from '../../app.config';
import { SearchSterlingService } from '../../services/search-sterling';

@Component({
    selector: 'app-search-sterling',
    templateUrl: 'search-sterling.html',
    styleUrls: ['search-sterling.css']
})

export class SearchSterlingComponent implements OnInit {

    results: any[];
    query: string;
    status = 'loading';
    dataSource: MatTableDataSource<any>;
    displayedColumns = ['first-name', 'last-name', 'order'];

    constructor(private config: AppConfigService,
        private search: SearchSterlingService) { }

    ngOnInit() {
        this.status = '';
            this.search.collection$.subscribe((data: any[]) => {
                this.results = data;
                this.status =  `${data.length} results`;
        });

        this.search.error$.subscribe(() => {
            this.status = 'No Records Found';
        });
      }

      getSearch() {

        if (this.query.length === 0 || !this.query.trim()) {
            this.results = [];
            this.status = '';
            return;
        }
        this.status = 'Searching...';

        const name = this.query.split(' ');
        let fname = null;
        let lname = null;
        if (name.length === 1) {
            lname = name[0];
        } else if (name.length === 2) {
            fname = name[0];
            lname = name[1];
        } else {
            this.results = [];
            this.status = 'No Records Found';
        }

        this.search.search(fname, lname);
      }

      rowClick(row: any) {
        const encoded = btoa(row.fileName);
        window.open(`${this.config.host}:8081/sterling/form/${encoded}`);
      }
}



// WEBPACK FOOTER //
// ./src/app/components/search-sterling/search-sterling.ts